module.exports = __webpack_public_path__ + "img/female_vampire_tablet.37571cc4.jpg";